define('v3/Common/Services/urlService',[
	'jquery',
	'module',
	'env',
	'lodash',
	'v3/Common/Models/enums',
	'v3/FromV2/localStorageV3Service',
	'v3/Common/Components/SubjectGroupsDropdown/Services/subjectGroupService'
], function ($, module, env, _, enums, localStorageV3Service, subjectGroupService) {
	var config = module.config();

	function createV4Url (subjectGroupId, urlPostfix) {
		var url = '/V4/' + env.userInfo.classId + '/';

		if (subjectGroupId) {
			return subjectGroupService.getAllSubjectGroups()
				.then(function (data) {
					var sg = _.find(data, { 'id': subjectGroupId });
					if (sg) {
						url = url + sg.subjectId + '/' + subjectGroupId + urlPostfix;
					}

					return $.Deferred().resolve(url);
				});
		}

		return $.Deferred().resolve(url);
	}

	function getScopeId (periodName) {
		switch (periodName) {
		case 'Now':
			return 0;
		case 'Today':
			return 1;
		case 'Yesterday':
			return 2;
		case 'ThisWeek':
			return 3;
		case 'PreviousWeek':
			return 4;
		default:
			return null;
		}
	}

	return {
		monitorPageUrl: function (subjectGroupId) {
			var url = config.actions.monitor;
			var cookie = localStorageV3Service.getSubjectGroupFilterStateLocalStorage();

			if (subjectGroupId) {
				url += '?subjectGroupId=' + subjectGroupId;
			} else if (cookie) {
				url += '?subjectGroupId=' + cookie.subjectGroupIdFilter;
			}

			return url;
		},

		lessonPageUrl: function (subjectGroupId) {
			var url;

			if (this.shouldRedirectToEducationPlan()) {
				url = config.actions.educationPlan;
				if (subjectGroupId) {
					url = url + '#subjectGroupId=' + subjectGroupId;
				}
			} else {
				url = config.actions.lessonPlan;
			}

			return url;
		},

		shouldRedirectToEducationPlan: function () {
			var savedPageState = localStorageV3Service.getEPPageStateLocalStorage();
			var subjectGroupFilterState = localStorageV3Service.getSubjectGroupFilterStateLocalStorage();
			return savedPageState && subjectGroupFilterState && savedPageState.pageView === enums.educationPlanViewMode.ReadOnlyView;
		},

		teachPageUrl: function (subjectGroupId) {
			return createV4Url(subjectGroupId, '/teach');
		},

		lessonMonitor: function (subjectGroupId, lessonPlanLessonId, lessonId) {
			return createV4Url(subjectGroupId, '/teach/monitor/' + lessonPlanLessonId + '/' + lessonId);
		},

		prepareLessonMonitorPageUrl: function (subjectGroupId, lessonPlanLessonId, lessonId) {
			if (!subjectGroupId || !lessonId || !lessonPlanLessonId) {
				return $.Deferred().reject();
			}
			return createV4Url(subjectGroupId, '/lesson/' + lessonId + '/monitor/' + lessonPlanLessonId);
		},

		learningLines: function (subjectGroupId, subDomainId, learningObjectiveId) {
			return createV4Url(subjectGroupId, '/learninglines/' + subDomainId + '/' + learningObjectiveId);
		},

		monitorPageV4Url: function (subjectGroupId, periodName) {
			var promise = $.Deferred();
			if (subjectGroupId) {
				return createV4Url(subjectGroupId, '/monitor');
			} else {
				var scopeId = getScopeId(periodName);
				var scopeUrl = '';
				if (scopeId) {
					scopeUrl = '?scope=' + scopeId;
				}

				return promise.resolve('/V4/' + env.userInfo.classId + '/all/all/monitor' + scopeUrl);
			}
		},

		reviewPageUrl: function () {
			return '/V4/' + env.userInfo.classId + '/all/all/review/class';
		},

		pupilReviewPageUrl: function (subjectGroupId, pupilId) {
			if (!subjectGroupId || !pupilId) {
				return $.Deferred().reject();
			}

			return createV4Url(subjectGroupId, '/review/pupil/' + pupilId);
		},

		digiboardPageUrl: function (subjectGroupId, lessonId, exerciseInLessonId) {
			if (!subjectGroupId || !lessonId) {
				return $.Deferred().reject();
			}

			return createV4Url(subjectGroupId, '/digiboard/' + lessonId + (exerciseInLessonId ? '/' + exerciseInLessonId : ''));
		},

		preparePageUrl: function (subjectGroupId, lessonId) {
			if (!subjectGroupId || !lessonId) {
				return $.Deferred().reject();
			}
			return createV4Url(subjectGroupId, '/lesson/' + lessonId + '/prepare');
		},

		pupilLearningObjectiveAnswerTimeline: function (subjectGroupId, pupilId, learningObjectiveId) {
			if (!subjectGroupId || !pupilId || !learningObjectiveId) {
				return $.Deferred().reject();
			}

			return createV4Url(subjectGroupId, '/review/pupil/' + pupilId + '/timeline/' + learningObjectiveId);
		}
	};
});
